import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Colors, Grids, MediaQueries, SectionInner, Spacings, } from "@polestar/component-warehouse-react";
const StyledTextWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  margin: ${Spacings.xxSmall};
`;
const LeadingCell = styled.div `
  width: ${(2 / Grids.mobile.columns) * 100}%;
  padding-right: calc(${Grids.mobile.gutter} * (2 / ${Grids.mobile.columns}));
  box-sizing: content-box;

  ${MediaQueries.tablet} {
    width: calc(
      ${(3 / Grids.tablet.columns) * 100}% - (${Spacings.medium} / 2)
    );
    padding-right: 0;
  }

  ${MediaQueries.desktop} {
    width: calc(${(4 / 8) * 100}%);
  }

  ${MediaQueries.desktopWide} {
    width: calc(${(3 / 8) * 100}% - (${Spacings.medium} / 2));
  }
`;
const TrailingCell = styled.div `
  ${MediaQueries.tablet} {
    padding-left: calc(${Grids.tablet.gutter} * (5 / ${Grids.tablet.columns}));
  }

  ${MediaQueries.desktop} {
    padding-left: calc(${Grids.desktop.gutter} * (4 / 8));
  }

  ${MediaQueries.desktopWide} {
    padding-left: calc(${Grids.desktop.gutter} * (5 / 8));
    margin-left: -${Spacings.xxSmall};
  }
`;
const StyledDefaultNotificationBar = styled.div `
  width: 100%;
  position: relative;
  padding: ${Spacings.small} 0;
  display: flex;
  align-items: center;
  min-height: 50px;
  margin-left: -${Spacings.xxSmall};
`;
const NotificationBarBackground = styled.div(() => css `
    background-color: ${Colors.signalWhite};
  `);
const StyledSectionInner = styled(SectionInner) `
  display: flex;
  align-items: center;
  padding: 0 ${Spacings.medium};

  ${MediaQueries.tablet} {
    padding: 0 ${Spacings.medium};
  }
`;
export { LeadingCell, NotificationBarBackground, StyledDefaultNotificationBar, StyledSectionInner, StyledTextWrapper, TrailingCell, };
